import { Card, CardActions, CardContent, CircularProgress, Typography } from "@mui/material"
import React from "react"
import SimpleTable from "../../components/Common/Elements"
import { useGetUserClanInfoTOHQuery } from "../../core/api/toh-clans-api"
import { format } from "date-fns"
import TohMuteControl from "./TohMuteControl"
import TohUnmuteControl from "./TohUnmuteControl"

const TohMuteStatusCard = ({ userId }) => {
    const { data: clanInfo, isLoading, isFetching } = useGetUserClanInfoTOHQuery(
        userId,
        { skip: userId === "" }
    )

    const mutedUntil = clanInfo?.mutedUntil ?? null
    const isMuted = mutedUntil != null && new Date(mutedUntil * 1000) > new Date()
    const mutedUntilDate = isMuted ? new Date(mutedUntil * 1000) : null
    const muteReason = clanInfo?.muteReason ?? null
    const muteCount = clanInfo?.mutedCount ?? null

    return (
        <Card>
            <CardContent>
                <Typography
                    sx={{
                        pb: 2,
                        fontSize: 16
                    }}>
                    Mute Status
                </Typography>
                {
                    isLoading || isFetching
                        ? (
                            <CircularProgress />
                        )
                        : (
                            <SimpleTable
                                data={[
                                    ["Muted", isMuted ? "Yes" : "No"],
                                    ["Until", mutedUntilDate ? format(mutedUntilDate, "dd MMM yyyy HH:mm") : "N/A"],
                                    ["Reason", muteReason || "N/A"],
                                    ["Count", muteCount != null ? muteCount.toString() : "N/A"]
                                ]}
                            />
                        )
                }
            </CardContent>
            <CardActions>
                <TohMuteControl disabled={isLoading || isFetching} userId={userId} />
                <TohUnmuteControl disabled={isLoading || isFetching} userId={userId} />
            </CardActions>
        </Card>
    );
}

export default TohMuteStatusCard
